import CIQClient, { HTTPClientResponse } from "./ciq-client";
import { BASE_URL_WITHOUT_GATEWAY } from "./endpoints";

export const getFeatureEntityLog = (
  projectToken: string,
  featureType: number,
  feature_instance_ids?: Array<string>
): Promise<HTTPClientResponse> => {
  const config = {
    headers: { Authorization: `Bearer ${projectToken}` }
  };

  let url = `${BASE_URL_WITHOUT_GATEWAY}/report-engine/logs/${featureType}`;

  if (feature_instance_ids && feature_instance_ids.length > 0) {
    url += `?feature_instance_ids=${feature_instance_ids.join(
      "&feature_instance_ids="
    )}`;
  }

  return CIQClient.get({
    url,
    config
  });
};
